import React from 'react'
import blueMt from '../img/aubackground.jpg'
import dots from '../img/dots.svg'
import bgImg from '../img/dots.svg'
import MobileHeroBg from '../img/auMobile.svg'
import COLORS from '../constants/colors';

const AboutTwo = () => {
  return (
    <>
      {/* Desktop/Laptop/Tablet Section */}
      {/* Desktop/Laptop/Tablet Section */}
      <section
        className="hidden sm:block relative bg-no-repeat bg-cover bg-center"
      // style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="relative min-h-[510px] lg:min-h-[51vh] max-h-[816px]">
          {/* Mountain (bottom-left) - Increased by 2% */}
          <img
            src={blueMt}
            alt="Mountains illustration"
            className="absolute bottom-0 left-0 z-10
        w-[320px] h-[172px]
        sm:w-[384px] sm:h-[207px]
        md:w-[513px] md:h-[275px]
        lg:w-[600px] lg:h-[323px]"
          />

          {/* Top-left dots - Conservative scaling to prevent overlap */}
          <img
            src={dots}
            alt=""
            className="absolute left-0 z-10
        top-[18px] w-[172px] h-[22px]
        sm:top-[21px] sm:w-[206px] sm:h-[27px]
        md:top-[28px] md:w-[275px] md:h-[36px]
        lg:top-[33px] lg:w-[322px] lg:h-[42px]"
          />

          {/* Bottom-right dots - Conservative scaling to prevent overlap */}
          <img
            src={dots}
            alt=""
            className="absolute right-0 z-10
        bottom-[18px] w-[172px] h-[22px]
        sm:bottom-[21px] sm:w-[206px] sm:h-[27px]
        md:bottom-[28px] md:w-[275px] md:h-[36px]
        lg:bottom-[33px] lg:w-[322px] lg:h-[42px]"
          />

          {/* Text block - Right half, vertically centered */}
          <div className="absolute left-1/2 top-1/2 -translate-y-1/2 z-20 w-1/2 pr-8 md:pr-12 lg:pr-16 xl:pr-20 2xl:pr-24">
            <div className="max-w-[600px] 2xl:max-w-[700px] min-[2560px]:max-w-[800px] space-y-4">
              <h2 className="font-[Quicksand] font-bold text-left
          text-[28px] leading-[35px] max-w-[85vw]
          md:text-[32px] md:leading-[38px] md:max-w-[50vw]
          lg:text-[36px] lg:leading-[42px] lg:max-w-[45vw]
          xl:text-[48px] xl:leading-[56px] xl:max-w-[568px]
          2xl:text-[56px] 2xl:leading-[64px] 2xl:max-w-[680px]
          min-[3840px]:text-[72px] min-[3840px]:leading-[80px] min-[3840px]:max-w-[1136px]">
                <span style={{ color: COLORS.primaryBlue }}>Who </span>
                <span style={{ color: COLORS.buttonColor }}>We are</span>
              </h2>
              <p className="font-[Quicksand] text-left
          text-[8px] leading-[8px] max-w-[318px]
          md:text-[10px] md:leading-[12px] md:max-w-[368px]
          lg:text-[12px] lg:leading-[14px] lg:max-w-[490px]
          xl:text-[16px] xl:leading-[22px] xl:max-w-[650px]
          2xl:text-[20px] 2xl:leading-[25px] 2xl:max-w-[680px]
          min-[3840px]:text-[36px] min-[3840px]:leading-[40px] min-[3840px]:max-w-[1510px]" style={{ color: COLORS.gray }}>
                Claim4Accidents is a dedicated legal support platform for individuals & families affected by motor vehicle accidents. We simplify the legal process by connecting victims of car, truck, & commercial vehicle accidents with experienced attorneys who specialize in personal injury & accident law.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Mobile Hero Section */}
      <section className="flex sm:hidden relative w-full h-[610px] flex-col items-start justify-between overflow-hidden ">
        {/* Background Image */}
        <img
          src={MobileHeroBg}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0 bg-#FDF9ED;/30 z-10" />

        {/* Content - Positioned at top */}
        <div className="relative z-20 flex flex-col items-start w-full px-4 pt-[97px]">
          <h1
            className="mb-4 text-left capitalize
              text-[24px] leading-normal
              font-[Quicksand] font-bold"
            style={{ color: COLORS.primaryBlue }}
          >
            Who <span style={{ color: COLORS.yellow }}>We are</span>
          </h1>

          <h2
            className="text-left
              text-[15px] leading-normal
              font-[Quicksand]"
            style={{ color: COLORS.gray }}
          >
            Claim4Accidents is a dedicated legal support platform for individuals & families affected by motor vehicle accidents. We simplify the legal process by connecting victims of car, truck, & commercial vehicle accidents with experienced attorneys who specialize in personal injury & accident law.
          </h2>
        </div>

      </section>
    </>
  )
}

export default AboutTwo